module.exports = __webpack_public_path__ + "static/img/02.141ebf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/02.jpg
// module id = em7J
// module chunks = 0